import React, { useState, useEffect } from 'react';
import { Flame, Trophy, Star, Zap, Crown, Award, X, Sparkles } from 'lucide-react';
import { Button } from "@/components/ui/button";

const MILESTONE_ICONS = {
  'Week Warrior': Zap,
  'Fortnight Focus': Star,
  'Monthly Master': Trophy,
  'Dedicated Writer': Award,
  'Century Scribe': Crown,
  'Year of Words': Flame,
};

const MILESTONE_MESSAGES = {
  'Week Warrior': "A full week of writing! You're building a real habit.",
  'Fortnight Focus': "Two weeks straight — your dedication is showing!",
  'Monthly Master': "A whole month of daily writing. That's extraordinary.",
  'Dedicated Writer': "60 days! You're not just writing — you're living the craft.",
  'Century Scribe': "100 days. One hundred. You are remarkable.",
  'Year of Words': "A full year of daily writing. You are a legend.",
};

const MilestoneCelebration = ({ milestone, onClose }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => setShow(true));
  }, []);

  if (!milestone) return null;

  const Icon = MILESTONE_ICONS[milestone.name] || Star;
  const message = MILESTONE_MESSAGES[milestone.name] || milestone.description;

  const handleClose = () => {
    setShow(false);
    setTimeout(onClose, 300);
  };

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-300 ${
        show ? 'opacity-100' : 'opacity-0'
      }`}
      data-testid="milestone-celebration"
    >
      <div className="absolute inset-0 bg-brand-dark/50 backdrop-blur-sm" onClick={handleClose} />

      <div
        className={`relative bg-white rounded-2xl shadow-2xl max-w-sm mx-4 overflow-hidden transition-all duration-500 ${
          show ? 'scale-100 translate-y-0' : 'scale-90 translate-y-8'
        }`}
      >
        {/* Decorative top */}
        <div className="bg-gradient-to-r from-amber-400 via-orange-500 to-red-400 p-6 text-center">
          <div className="w-20 h-20 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mx-auto mb-3">
            <Icon className="w-10 h-10 text-white" />
          </div>
          <Sparkles className="w-5 h-5 text-white/80 absolute top-4 right-12 animate-pulse" />
          <Sparkles className="w-4 h-4 text-white/60 absolute top-8 left-10 animate-pulse" style={{ animationDelay: '0.5s' }} />
        </div>

        <div className="p-6 text-center">
          <p className="text-xs font-medium text-brand-gold uppercase tracking-widest mb-2">
            Milestone Unlocked!
          </p>
          <h3 className="font-serif text-2xl font-semibold text-text-primary mb-2" data-testid="milestone-name">
            {milestone.name}
          </h3>
          <p className="text-text-secondary leading-relaxed mb-1">
            {message}
          </p>
          <p className="text-sm text-text-muted mb-6">
            {milestone.days} consecutive days of writing
          </p>

          <Button onClick={handleClose} className="btn-accent w-full gap-2" data-testid="milestone-close-button">
            <Flame className="w-4 h-4" />
            Keep the Streak Going!
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MilestoneCelebration;
